<template>
  <div class="w-100 p-5 container">
    <view-json v-if="currentJob.state === 'completed'"></view-json>
  </div>
</template>
<script>
import store from './../../../mixins/store.mixin'
import currentJob from './../../../mixins/current_job.mixin'
import ViewJson from "../../Viewer/Json/ViewJson.vue";

export default {
  name: "OutputMetadata",
  props: {},
  components: {ViewJson},
  mixins: [
    store,
      currentJob
  ],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {},
  computed: {}
};
</script>
<style lang="scss" scoped>
</style>
